
import VisitorCounter from "../VisitorCounter/VisitorCounter";
import "./Footer1.css";

export default function Footer() {
  return (
    <footer className="site-footer">
      <p>© 2026 Our Country Our People</p>
      <VisitorCounter/>
    </footer>
  );
}
